import React, { useRef } from "react";

interface Props {
  src: string;
  /** 표시 높이(px). 폭은 영상 비율에 따라 자동. */
  height?: number;
  maxWidth?: number;
  title?: string;
}

/**
 * 키워드 API 응답에는 썸네일(imagePath)이 없고 videoPath 만 있다. 첫 프레임을
 * 미리보기로 쓰기 위해 metadata 만 프리로드하고, 마우스를 올리면 무음으로 재생한다.
 * 목록 하나에 수십 개가 놓이므로 preload="auto" 는 쓰지 않는다.
 */
const TemplateVideo = ({ src, height = 96, maxWidth = 140, title }: Props) => {
  const ref = useRef<HTMLVideoElement | null>(null);

  const play = () => {
    const v = ref.current;
    if (!v) return;
    v.play().catch(() => {
      /* autoplay 정책으로 막히면 첫 프레임만 보여준다 */
    });
  };
  const stop = () => {
    const v = ref.current;
    if (!v) return;
    v.pause();
    v.currentTime = 0;
  };

  return (
    // eslint-disable-next-line jsx-a11y/media-has-caption
    <video
      ref={ref}
      src={src}
      title={title}
      muted
      playsInline
      loop
      preload="metadata"
      onMouseEnter={play}
      onMouseLeave={stop}
      style={{
        height,
        maxWidth,
        width: "auto",
        borderRadius: 4,
        backgroundColor: "#000",
        display: "block",
        objectFit: "contain",
      }}
    />
  );
};

export default TemplateVideo;
